<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="goodTypeTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="coverPath" slot-scope="data">
          <img class="table-img" v-if="data.row.coverPath && data.row.coverPath.length > 0" :src="imgUrl + data.row.coverPath">
        </template>
      </wt-form-table-list>
    </wt-form-table>
    <el-dialog
      title=""
      :visible.sync="editObj.visible"
      width="30%"
      :modal="false"
      append-to-body
      class="min-dialog-wrap"
      :show-close="false"
      :before-close="handleClose">
      <div class="dialog-input-card">
        <el-form v-if="editObj.visible" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="商品类型:" prop="name" required>
            <el-input type="text" v-model="ruleForm.name" placeholder="请输入商品类型"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_GOODSTYPE',
        formComponent: {
          list: { type: 'default', value: '/modules/goodsType/goodsTypePageList' },
          delete: { type: 'default', value: '/modules/goodsType/goodsTypeDelete' }
        },
        formInputsData: [
          { name: '商品类型', key: 'name', value: '', type: 'text' }],
        formButtonsData: [{ name: '新增', key: 'ADDTYPE', action: 'ADDTYPE', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '商品类型', key: 'name', type: 'text' }],
        formTableButtonsData: [{ name: '编辑', key: 'EDITTYPE', action: 'EDITTYPE', className: 'primary', hidden: false, permission: 'EDIT' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      },
      ruleForm: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入商品类型', trigger: 'blur' },
          { min: 1, max: 20, message: '商品类型长度不能超过20', trigger: 'blur' }
        ]
      },
      editObj: {
        visible: false,
        limit: 1
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'ADDTYPE') {
          this.ruleForm = {
            name: ''
          }
          this.editObj.visible = true
        }
        if (data.item.action === 'EDITTYPE') {
          this.ruleForm = JSON.parse(JSON.stringify(data.row))
          this.editObj.visible = true
        }
      }
    },
    handleClose() {
      this.editObj.visible = false
    },
    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.id) {
            request({
              url: '/modules/goodsType/goodsTypeUpdate',
              method: 'post',
              data: this.ruleForm
            }).then(res => {
              if (res.code === '0') {
                that.$message({ message: '保存成功', type: 'success' })
                this.$refs.goodTypeTableRef.requestList()
                that.handleClose()
              }
            })
          } else {
            request({
              url: '/modules/goodsType/goodsTypeAdd',
              method: 'post',
              data: this.ruleForm
            }).then(res => {
              if (res.code === '0') {
                that.$message({ message: '保存成功', type: 'success' })
                this.$refs.goodTypeTableRef.requestList()
                that.handleClose()
              }
            })
          }
        } else { return false }
      })
    }
  }
}
</script>
